import DOMPurify from "dompurify";

// eslint-disable-next-line no-undef
let $globalConfig;
if (document.querySelectorAll('.catalog').length > 0 || document.querySelectorAll('.eifu').length > 0) {
    $globalConfig = config;
}

const eifuconfig = {
    selectors: {
        resultList: '.eifu-search-results-list',
        resultListItem: '.eifu-search-results-list__item',
        versionSelect: '.eifu-search-result__select',
        buttonContainer: '.eifu-search-result__btn-container',
        orderButton: '.eifu-search-result__btn--order',
        downloadButton: '.eifu-search-result__btn--download',
        versionDD: '.eifu-search-result__version-dd',
        title: '.eifu-search-result__title',
        language: '.eifu-search-result__language',
        info: '.eifu-search-result__info',
    },
};

function init() {
    $(eifuconfig.selectors.resultList).each((i, el) => {
        const $searchResultList = $(el);
        initSearchResultList($searchResultList);
    });
}

function initSearchResultList($searchResultList) {
    initSearchResultItems($searchResultList);
}

function initSearchResultItems($searchResultList) {
    const $searchResultItems = $searchResultList
        .find(eifuconfig.selectors.resultListItem);

    $searchResultItems.each((i, el) => {
        const $searchResultItem = $(el);
        initSearchItem($searchResultItem);
    });
}

function initSearchItem($searchResultItem) {
    const $versionSelect = $searchResultItem
        .find(eifuconfig.selectors.versionSelect);

    const $orderButton = $searchResultItem.find(eifuconfig.selectors.orderButton);
    const $downloadButton = $searchResultItem.find(eifuconfig.selectors.downloadButton);
    // const $versionDD = $searchResultItem.find(eifuconfig.selectors.versionDD);
    const $title = $searchResultItem.find(eifuconfig.selectors.title);
    const $articleid = $searchResultItem.attr('data-article');
    const $eifuid = $searchResultItem.attr('data-identifier');
    const $info = $searchResultItem.find(eifuconfig.selectors.info);

    const selectedVersion = {
        version: null,
        index: 0,
    };

    function handleVersionChange(version, index) {
        const versionChanged = $versionSelect.attr('data-selected') !== version;

        if (!versionChanged) {
            return;
        }
        let solrURL = $globalConfig.urls.getEifuResultsJson;
        const url = new URL(window.location.href);
        const language = DOMPurify.sanitize(url.searchParams.get('language')) || $globalConfig.mainLanguage;
        const country = DOMPurify.sanitize(url.searchParams.get('country')) || $globalConfig.mainCountry;

        // console.log('language before sanitize: ', url.searchParams.get('language'));
        // console.log('language after sanitize: ', DOMPurify.sanitize(url.searchParams.get('language')));

        // console.log('country before sanitize: ', url.searchParams.get('country'));
        // console.log('country after sanitize: ', DOMPurify.sanitize(url.searchParams.get('country')));


        solrURL += `${language}/?v=${version}&ifuId=${$eifuid}&country=${country}&websiteLanguage=${$globalConfig.mainLanguage}&articleNumber=${$articleid}`;
        jQuery.ajax({
            type: 'GET',
            url: solrURL,
            processData: false,
            dataType: 'json',
            success(data) {
                if (data.response.numFound !== 0) {
                    const eifuResult = data.response.docs[0];
                    const date = new Date(eifuResult.IssueDate_dt);
                    const options = { year: 'numeric', month: '2-digit' };
                    $title.text(eifuResult.Title_s);
                    let infoData = '';
                    let downloadData = '';
                    infoData += `<dt>${$globalConfig.labels.eifu.labelLanguage}</dt><dd class="eifu-search-result__language">${eifuResult.Language_s ? eifuResult.Language_s : $globalConfig.labels.eifu.labelNoResult}</dd>`;
                    infoData += `<dt>${$globalConfig.labels.eifu.labelIssueDate}</dt><dd>${eifuResult.IssueDateOriginal_s ? date.toLocaleDateString(`${$globalConfig.mainCountry}`, options) : $globalConfig.labels.eifu.labelNoResult}</dd>`;
                    if (eifuResult.ExecutingSpecialty_ss) {
                        infoData += `<dt>${$globalConfig.labels.eifu.labelAreaOfExpertise}</dt><dd>`;
                        let executingSpecialtyValue = '';
                        eifuResult.ExecutingSpecialty_ss.forEach((executingSpecialty) => {
                            executingSpecialtyValue += executingSpecialtyValue !== '' ? `,${executingSpecialty}` : executingSpecialty;
                        });
                        infoData += `${executingSpecialtyValue}</dd>`;
                    } else {
                        infoData += `<dt>${$globalConfig.labels.eifu.labelAreaOfExpertise}</dt><dd>${$globalConfig.labels.eifu.labelNoResult}</dd>`;
                    }
                    infoData += `<dt>${$globalConfig.labels.eifu.labelEdition}</dt><dd class="eifu-search-result__version-dd">${eifuResult.Version_s ? eifuResult.Version_s : $globalConfig.labels.eifu.labelNoResult}</dd>`;
                    infoData += `<dt>${$globalConfig.labels.eifu.labelDeviceVersion}</dt><dd>${eifuResult.DeviceVersion_s ? eifuResult.DeviceVersion_s : $globalConfig.labels.eifu.labelNoResult}</dd>`;
                    if (eifuResult.RegulatorySystem_ss) {
                        infoData += `<dt>${$globalConfig.labels.eifu.labelRegulatorySpace}</dt><dd>`;
                        let regulatorySystemValue = '';
                        eifuResult.RegulatorySystem_ss.forEach((regulatorySystem) => {
                            regulatorySystemValue += regulatorySystemValue !== '' ? `,${regulatorySystem}` : regulatorySystem;
                        });
                        infoData += `${regulatorySystemValue}</dd>`;
                    } else {
                        infoData += `<dt>${$globalConfig.labels.eifu.labelRegulatorySpace}</dt><dd>${$globalConfig.labels.eifu.labelNoResult}</dd>`;
                    }   
                    infoData += `<dt>${$globalConfig.labels.eifu.labelSoftwareVersion}</dt><dd>${eifuResult.SoftwareVersion_s ? eifuResult.SoftwareVersion_s : $globalConfig.labels.eifu.labelNoResult}</dd>`;
                    downloadData += `<span class="eifu-search-result__btn-icn material-icons" aria-hidden="true">vertical_align_bottom</span>${$globalConfig.labels.eifu.labelDownload}<small> (PDF ${eifuResult.FileSizeConverted_s})</small>`;
                    $searchResultItem.attr('data-id', DOMPurify.sanitize(eifuResult.FileId_s));
                    $info.text('');
                    $info.append(DOMPurify.sanitize(infoData));
                    $downloadButton.attr('href', `${$globalConfig.urls.eifuDownloadURL}?id=${DOMPurify.sanitize(eifuResult.FileId_s)}`);
                    $downloadButton.text('');
                    $downloadButton.append(downloadData);
                }
            },
            error() {
                // eslint-disable-next-line no-console
                // console.log('Error loading eifu result!');
            },
        });
        $versionSelect.attr('data-selected', version);
        selectedVersion.version = version;
        selectedVersion.index = index;
    }

    $versionSelect.on('MDCSelect:change', (e) => {
        const { originalEvent: { detail: { value: version, index } } } = e;
        handleVersionChange(version, index);
    });

    $orderButton.on('click', (e) => {
        e.preventDefault();

        const basketLink = `${$globalConfig.urls.addToCart}?action=addeifu&eifu_id=${$searchResultItem.attr('data-id')}&title=${encodeURIComponent($searchResultItem.find(eifuconfig.selectors.title).text())}&language=${$searchResultItem.find(eifuconfig.selectors.language).text()}`;

        if (basketLink !== '') {
            $.get(basketLink, (data) => {
                const mediaquery = window.matchMedia('(max-width: 991px)');

                if (mediaquery.matches) {
                    $('#ks-cart-count').replaceWith(data);
                    $('#ks-mobile-button-cart').animate({ opacity: 0 }, 500);
                    $('#ks-mobile-button-cart').addClass('full');
                    $('#ks-mobile-button-cart').animate({ opacity: 1 }, 500);
                } else {
                    $('#ks-top-cart-dialog').animate({ opacity: 0 }, 500);
                    $('#ks-cart-count').replaceWith(data);
                    $('#ks-top-cart-dialog').animate({ opacity: 1 }, 500);
                    $('#ks-mobile-button-cart').addClass('full');
                }

                // eslint-disable-next-line no-undef
                toastr.options.onclick = () => {
                    const $basketLink = $('.navigation__action.navigation__action--favorite > a');
                    if ($basketLink.length) {
                        // click the basket link so that the user
                        // navigates to the basket page when he
                        // clicked a toastr popup
                        $basketLink[0].click();
                    }

                    // eslint-disable-next-line no-undef
                    toastr.options.onclick = null;
                };

                // eslint-disable-next-line no-undef
                toastr.info(`<div><b>${decodeURIComponent($title.text())}</b> ${$globalConfig.labels.add_to}.</div>`);
            });
        }
    });
}

if (document.querySelectorAll('.eifu').length > 0) {
    init();
}
